import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CrosscuttingModule } from '@crosscutting/public_api';

import { VMNavigationService } from './vmnavigation.service';
import { VMRefreshSessionService } from './vmrefresh-session.service';

import { VMDataService } from './vmdata.service';

@NgModule({
  imports: [
    CommonModule,
    CrosscuttingModule.forRoot()
  ],
  exports: [
    CommonModule,
  ]
})

export class VMComponentsModule {
  static forRoot(): ModuleWithProviders<VMComponentsModule> {
    return {
      ngModule: VMComponentsModule,
      providers: [
        VMDataService,
        VMNavigationService,
        VMRefreshSessionService
      ],
    };
  }
}
